<template>
    <b-row>
        <b-col class="px-1">
            <toggle-batch-button
                :submitting="toggles.submitting_select"
                :side="toggles.select_from"
                :value="toggles.select_value"
                :options="toggles.select_options"
                process="select"
                @applyToggle="applyToggle"
                @updateToggleSelector="updateToggleSelector"
                @updateToggleValue="updateToggleValue"
            />
        </b-col>
        <b-col class="px-1">
            <toggle-batch-button
                :submitting="toggles.submitting_remove"
                :side="toggles.remove_from"
                :value="toggles.remove_value"
                :options="toggles.remove_options"
                process="remove"
                @applyToggle="applyToggle"
                @updateToggleSelector="updateToggleSelector"
                @updateToggleValue="updateToggleValue"
            />
        </b-col>
        <b-col class="px-1">
            <toggle-select-button 
                v-if="toggles.status"
                :status_options="toggles.status_options"
                :default_value="toggles.status"
                @selectedOption="updateSelectedOption"
            />
        </b-col>
    </b-row>
</template>

<script>
import ToggleBatchButton from "@/components/shared/form/ToggleBatchButton";
import ToggleSelectButton from "@/components/shared/form/ToggleSelectButton";
import { getCollection } from "@/shared/fetch-utils";

export default {
    name: "BatchResultManagerServerTableActions",
    components: {
        ToggleBatchButton,
        ToggleSelectButton
    },
    data() {
        return {
            toggles: {
                select_options: [
                  { text: "Select From Top", value: "top" },
                  { text: "Select From Bottom", value: "bottom" },
                ],
                remove_options: [
                  { text: "Remove From Top", value: "top" },
                  { text: "Remove From Bottom", value: "bottom" },
                ],
                status_options: [],
                select_from: "top",
                remove_from: "top",
                status: null,
                select_value: 0,
                remove_value: 0,
                status_value: 0,
                submitting_select: false,
                submitting_remove: false,
                submitting_status: false,
            },
        };
    },
    methods: {
        applyToggle(process, side) {
            this.$emit('toggle', {
                process: process,
                side: side,
                value: this.toggles[`${process}_value`]
            });
        },
        updateToggleSelector({ process, value }) {
            this.toggles[`${process}_from`] = value;
        },
        updateToggleValue({ process, value }) {
            this.toggles[`${process}_value`] = value;
        },
        updateSelectedOption(option) {
            this.$emit('option', option)
        },
        async getAnalyteStatus() {
            const statuses = await getCollection({
                collection_type: "analyte_result_status",
                message: this.$bvToast
            });

            const first_approved = statuses.models.find(e => e.status === "Approved");

            this.toggles.status = first_approved.id;
            
            statuses.models.splice(statuses.models.findIndex(e => e.status === "Pending"), 1);

            this.toggles.status_options = statuses.map(({id, status}) => {
                if (id && status) {

                    return { value: id, text: status };
                }
            });
        },
        async init() {
            this.getAnalyteStatus();
        }
    },
    created() {
        this.init()
    },
};
</script>